import React from 'react';
import Calculator from "./Calculator";

const UtilCalc = () => {
    return (
        <div className="utils-elixirs__body">
            <Calculator isUtils={true}/>
        </div>
    );
};

export default UtilCalc;